module.exports = __webpack_public_path__ + "public/img/still.965c10a4.png";